import { useContext } from "react";

import { useHistory } from "react-router-dom";

import Box from "@/components/Box";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_PATIENTS_REPORT_TAB_URL, getCmpUrl } from "@/core/urls";
import Stack from "@/tpo/Stack";
import { ViewerContext } from "@/tpo/Viewer";
import { useQuery } from "@apollo/client";
import { useTheme } from "styled-components";

import Template from "../shared/Template";
import { PATIENT_ENTITLEMENTS_QUERY, REPORTS_LIST_QUERY } from "./graphql/queries";
import ReportsGrid from "./reportList/ReportGrid";

export default function PatientReports({ templateProps }) {
  const theme = useTheme();
  const history = useHistory();
  const { organisation } = useOrganisationContext();
  const { userId } = useContext(ViewerContext);

  const { data: entitlementsData } = useQuery(PATIENT_ENTITLEMENTS_QUERY, {
    variables: {
      userId: userId,
      organisationId: organisation?.id
    },
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first",
    skip: !organisation || !userId
  });

  return (
    <Template selectedTab="reports" docTitle="Patient reports" {...templateProps}>
      <Box bg="white">
        <Box pt={theme.spacing.section.pt} pb={theme.spacing.section.pb} px={16}>
          <Stack maxWidth={720} mx="auto" gap={16} width="100%">
            <Box
              fontFamily="gilroyBold"
              fontSize={[32, 32, 44]}
              lineHeight={["36px", "36px", "50px"]}
            >
              Reports
            </Box>
            <Box
              fontFamily="gilroyMedium"
              fontSize={[14, 14, 16]}
              lineHeight={["24px", "24px", "28px"]}
            >
              Our reports give you a powerful way to understand your patient’s health by combining
              their DNA insights with relevant functional markers. Each report turns complex data
              into clear, clinically focused stories that help you spot patterns faster, guide more
              targeted interventions, and deliver a more personalised standard of care.
            </Box>
          </Stack>
        </Box>
      </Box>
      <ReportsGrid
        query={REPORTS_LIST_QUERY}
        queryVariables={{
          userId,
          organisationId: organisation?.id
        }}
        listName="reports"
        onReportClick={report => {
          history.push(
            getCmpUrl(CMP_PATIENTS_REPORT_TAB_URL, {
              organisationId: organisation?.hashId,
              patientId: userId,
              reportSlug: report.slug,
              tab: "overview"
            })
          );
        }}
        userEntitlements={entitlementsData?.user?.entitlements}
      />
    </Template>
  );
}
